import { render, staticRenderFns } from "./IbVuetifyApp.vue?vue&type=template&id=0df8f41d"
import script from "./IbVuetifyApp.vue?vue&type=script&lang=js"
export * from "./IbVuetifyApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports